import React, { useEffect, useState } from "react";
import performRequest from "../../../api/request";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import Footer from "../../../Components/Footer/footer";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FcAlarmClock, FcClearFilters, FcFinePrint } from "react-icons/fc";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaEye } from "react-icons/fa";
import { extractDate } from "../../../Components/Functions/date.fun";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";

const InterviewPipelineSystem = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [socialMedia, setSocialMedia] = useState([]);
  const [pageMap, setPageMap] = useState({});
  const ITEMS_PER_PAGE = 20;
  const [openFollowup, setOpenFollowup] = useState(null);

  const toggleFollowup = (id) => {
    setOpenFollowup(openFollowup === id ? null : id);
  };

  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    interviewDate: "",
    candidateName: "",
    departments: "",
    assignedInterviewer: "",
  });

  const statusScripts = {
    "Pending Interview": "Candidates waiting for interview",
    "First Round": "First round interview schedule",
    "Second Round": "Second round interview schedule",
    "Third Round": "Final round interview schedule",
    Selected: "Selected candidates",
    Rejected: "Rejected candidates",
  };

  // ✅ YOUR MARKETING STATUSES (change if needed)
  const statuses = [
    "Pending Interview",
    "First Round",
    "Second Round",
    "Third Round",
    "Selected",
    "Rejected",
  ];

  // ✅ FETCH DATA
  // useEffect(() => {
  //   setLoading(true);
  //   performRequest("GET", getFilteredURL("/content/get-pipelines", 1, filters))
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setData(res.data);
  //       }
  //     })
  //     .catch((err) => CustomErrorResponse(err))
  //     .finally(() => setLoading(false));
  // }, [refresh]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/interview-pipeline/get-interviews", 1, {
        ...filters,
        pageMap: JSON.stringify(pageMap),
        limit: ITEMS_PER_PAGE,
      })
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        }
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [refresh, pageMap]);

  // ✅ GET ITEMS BY STATUS
  // const getItemsByStatus = (status) => {
  //   return data?.[status] || [];
  // };

  const getItemsByStatus = (status) => {
    const statusData = data?.[status] || {};

    return {
      paginatedItems: statusData.data || [],
      totalItems: statusData.total || 0,
      currentPage: statusData.page || 1,
      totalPages: statusData.totalPages || 1,
    };
  };

  // ✅ DRAG END HANDLER
  const handleDragEnd = async (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) return;

    const sourceStatus = source.droppableId;
    const destStatus = destination.droppableId;

    if (sourceStatus === destStatus) return;

    try {
      let res = await performRequest(
        "PATCH",
        `/interview-pipeline/update/${draggableId}`,
        {
          interviewSatatus: destStatus,
        }
      );

      if (res.status === 200) {
        // Toast("success", "Moved successfully");
      }

      setRefresh((prev) => !prev);
    } catch (err) {
      // CustomErrorResponse(err);
      Toast("error", err?.response?.data?.message || "Something went wrong");
    }
  };

  const handleNext = (status) => {
    setPageMap((prev) => ({
      ...prev,
      [status]: (prev[status] || 1) + 1,
    }));
  };

  const handlePrev = (status) => {
    setPageMap((prev) => ({
      ...prev,
      [status]: Math.max((prev[status] || 1) - 1, 1),
    }));
  };

  if (loading) return <LoadingPage />;

  const handleView = (item) => {
    navigate(`/view-candidate-details/${item?.ref_id}`);
  };

  const handleEdit = (item) => {
    navigate(`/update-candidate-details/${item?.ref_id}`);
  };

  return (
    <div className="page p-4">
      <div className="page-wrapper">
        <div className="card shadow-sm p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            {/* Heading */}
            <h2 className="fw-bold mb-0">
              <FcAlarmClock style={{ height: "30px", width: "30px" }} />{" "}
              Interview Schedule Pipeline
            </h2>

            {/* Right Side Buttons */}
            <div className="d-flex flex-wrap justify-content-end gap-2">
              {/* Filter Dropdown */}
              <div className="dropdown">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <FcClearFilters size={18} />
                  <span className="ms-1">Apply Filters</span>
                </button>

                <div
                  className="dropdown-menu dropdown-menu-end p-3"
                  style={{ minWidth: "320px" }}
                >
                  <DynamicFilterInput
                    label="Start Date"
                    value={filters.startdate}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        startdate: e.target.value,
                      })
                    }
                    type="date"
                  />

                  <DynamicFilterInput
                    label="End Date"
                    value={filters.enddate}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        enddate: e.target.value,
                      })
                    }
                    type="date"
                  />

                  <DynamicFilterInput
                    label="Interview Date"
                    value={filters.interviewDate}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        interviewDate: e.target.value,
                      })
                    }
                    type="date"
                  />

                  <DynamicFilterInput
                    label="Candidate Name"
                    value={filters.candidateName}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        candidateName: e.target.value,
                      })
                    }
                    type="text"
                    placeholder="Search Candidate"
                  />

                  <div className="col-12">
                    <DynamicFilterSelect
                      label="Department"
                      value={filters.departments}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          departments: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="Business Development Department">
                        Business Development Department (Sales)
                      </option>
                      <option value="Operations Executive Department">
                        Operations Executive Department (Purchase)
                      </option>
                      <option value="Social Media Marketing Department">
                        Social Media Marketing Department (Video Editing,
                        Graphic Design)
                      </option>
                      <option value="Human Resources">
                        Human Resources Department
                      </option>
                      <option value="Accounting Department">
                        Accounting Department
                      </option>
                      <option value="Management Department">
                        Management Department
                      </option>
                      <option value="Agronomist Department">
                        Agronomist Department
                      </option>
                    </DynamicFilterSelect>
                  </div>

                  <div className="col-12">
                    <DynamicFilterSelect
                      label="Assigned Interviewer"
                      value={filters.assignedInterviewer}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          assignedInterviewer: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="Sudhir Devkar">Sudhir Devkar</option>
                      <option value="Priya Devkar">Priya Devkar</option>
                      <option value="Saloni Kadam">Saloni Kadam</option>
                      <option value="Other">Other</option>
                    </DynamicFilterSelect>
                  </div>

                  <div className="d-flex gap-2 mt-3">
                    <button
                      className="btn btn-primary flex-fill"
                      onClick={() => setRefresh((prev) => !prev)}
                    >
                      Search
                    </button>

                    <button
                      className="btn btn-secondary flex-fill"
                      onClick={() => {
                        setFilters({
                          startdate: "",
                          enddate: "",
                          interviewDate: "",
                          candidateName: "",
                          assignedInterviewer: "",
                          departments: "",
                        });

                        setRefresh((prev) => !prev);
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              {/* Add Candidate Button */}
              <button
                className="btn btn-success"
                onClick={() => navigate("/add-candidate-details")}
              >
                + Candidate Interview Schedule
              </button>

              {/* View Candidate List Button */}
              <button
                className="btn btn-primary"
                onClick={() => navigate("/candidates")}
              >
                View Candidate List
              </button>
            </div>
          </div>
        </div>

        <div className="page-body mt-2">
          <DragDropContext onDragEnd={handleDragEnd}>
            <div className="card">
              <div
                className="card-body"
                style={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "1rem",
                  minHeight: "80vh",
                }}
              >
                {statuses.map((status) => {
                  // const items = getItemsByStatus(status);

                  const {
                    paginatedItems,
                    totalItems,
                    currentPage,
                    totalPages,
                  } = getItemsByStatus(status);

                  return (
                    <Droppable droppableId={status} key={status}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          className="border"
                          {...provided.droppableProps}
                          style={{
                            minWidth: "280px",
                            background: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "10px",
                            maxHeight: "80vh",
                            overflowY: "auto",
                          }}
                        >
                          <h3
                            style={{
                              textAlign: "center",
                              background: "#000",
                              color: "#fff",
                              padding: "8px",
                              borderRadius: "6px",
                              textTransform: "uppercase",
                            }}
                          >
                            {/* {status} ({items.length}) */}
                            {status} ({totalItems})
                          </h3>
                          <div
                            className="border mb-2 p-2 bg-gray-500 text-gray-500-fg text-center"
                            style={{ height: "50px" }}
                          >
                            <p className="fs-5" style={{ fontWeight: "bold" }}>
                              {statusScripts[status]}
                            </p>
                          </div>
                          {paginatedItems.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id.toString()}
                              index={index} // ✅ FIXED
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  // className={`card mb-2 p-2 ${
                                  //   item?.finalPhotos === "green"
                                  //     ? "bg-green-lt"
                                  //     : statusColors[status]
                                  // }`}
                                  className={`card mb-2 p-2 ${
                                    item?.interviewSatatus ===
                                    "Pending Interview"
                                      ? "bg-red-lt"
                                      : item?.interviewSatatus === "First Round"
                                      ? "bg-blue-lt"
                                      : item?.interviewSatatus ===
                                        "Second Round"
                                      ? "bg-yellow-lt"
                                      : item?.interviewSatatus === "Third Round"
                                      ? "bg-teal-lt"
                                      : item?.interviewSatatus === "Selected"
                                      ? "bg-green-lt"
                                      : "bg-red-lt"
                                  }`}
                                >
                                  {/* <div className="mt-1">
                                    <strong className="fs-3">
                                      {item?.contentCardId || "N/A"}
                                    </strong>
                                  </div>

                                  <hr className="mt-2 mb-1" /> */}
                                  <div className="mt-1">
                                    <strong>Interview Date :</strong>{" "}
                                    {item?.interviewScheduleDate
                                      ? extractDate(item?.interviewScheduleDate)
                                      : "Not Scheduled"}
                                  </div>
                                  <div className="mt-1">
                                    <strong>Position :</strong>{" "}
                                    {item?.position || "N/A"}
                                  </div>

                                  <div className="mt-1">
                                    <strong>Name :</strong>{" "}
                                    {item?.Fname || "N/A"}
                                  </div>

                                  {/* <div className="mt-1">
                                    <strong>Phone :</strong>{" "}
                                    {item?.phoneNo || "N/A"}
                                  </div> */}

                                  <div className="mt-1">
                                    <strong>Email :</strong>{" "}
                                    {item?.email || "N/A"}
                                  </div>

                                  <div className="mt-1">
                                    <strong>Interview Type:</strong>{" "}
                                    {item?.interviewType || "N/A"}
                                  </div>

                                  {/* <div className="mt-1">
                                    <strong>Job Type :</strong>{" "}
                                    {item?.jobType || "N/A"}
                                  </div> */}

                                  <div className="mt-1">
                                    <strong>Department :</strong>{" "}
                                    {item?.departments || "N/A"}
                                  </div>

                                  <div className="mt-1">
                                    <strong>Interviewer :</strong>{" "}
                                    {item?.assignedInterviewer ||
                                      "Not Assigned"}
                                  </div>

                                  <hr className="my-1" />
                                  {/* FOLLOWUP BUTTON */}
                                  <div
                                    style={{
                                      marginTop: "2px",
                                      cursor: "pointer",
                                      fontWeight: "600",

                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => toggleFollowup(item.id)}
                                  >
                                    <div
                                      className={` ${
                                        item?.interviewSatatus ===
                                        "Pending Interview"
                                          ? "bg-red-lt"
                                          : item?.interviewSatatus ===
                                            "First Round"
                                          ? "bg-blue-lt"
                                          : item?.interviewSatatus ===
                                            "Second Round"
                                          ? "bg-yellow-lt"
                                          : item?.interviewSatatus ===
                                            "Third Round"
                                          ? "bg-teal-lt"
                                          : item?.interviewSatatus ===
                                            "Selected"
                                          ? "bg-green-lt"
                                          : "bg-red-lt"
                                      }`}
                                    >
                                      Last Follow Up
                                    </div>
                                    <div>
                                      {openFollowup === item.id ? "▲" : "▼"}
                                    </div>
                                  </div>
                                  {/* FOLLOWUP DETAILS */}
                                  {openFollowup === item.id && (
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        background: "#ffffff",
                                        padding: "8px",
                                        borderRadius: "4px",
                                        fontSize: "13px",
                                      }}
                                    >
                                      {item?.followUp?.map((item, index) => (
                                        <div
                                          key={item?.id || index}
                                          style={{ marginBottom: "6px" }}
                                        >
                                            <div>
                                            <strong>Created By:</strong>{" "}
                                            {item?.createdByUser?.userName || "N/A"}
                                          </div>
                                          <div>
                                            <strong>Followup Date:</strong>{" "}
                                            {item?.followUpDate || "N/A"}
                                          </div>

                                          <div>
                                            <strong>Followup Message:</strong>{" "}
                                            {item?.followUp || "No Message"}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* <div className="mt-1">
                                    <strong>Recruiter Remark :</strong>{" "}
                                    {item?.recruterRemark || "N/A"}
                                  </div> */}

                                  {/* <div className="mt-1">
                                    <strong>Created :</strong>{" "}
                                    {extractDate(item?.createdAt)}
                                  </div> */}

                                  {/* <hr className="m-0 p-0"></hr> */}
                                  <div className="d-flex flex-wrap gap-2 mt-2">
                                    <button
                                      className="btn btn-sm btn-light border"
                                      onClick={() => handleView(item)}
                                      title="View"
                                    >
                                      <FaEye />
                                      &nbsp;View
                                    </button>

                                    <button
                                      className="btn btn-sm btn-light border"
                                      onClick={() => handleEdit(item)}
                                      title="Edit"
                                    >
                                      <FaEdit />
                                      &nbsp;Edit
                                    </button>

                                    <a
                                      href={item?.uploadcv}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-sm btn-light border"
                                      title="Open Resume"
                                    >
                                      <FaEdit />
                                      &nbsp;Resume
                                    </a>

                                    {item?.Schedulelink && (
                                      <a
                                        href={item.Schedulelink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-light border"
                                        title="Join Interview"
                                      >
                                        📹 &nbsp; join Interview
                                      </a>
                                    )}
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}

                          {provided.placeholder}
                          {/* ✅ PAGINATION BUTTONS */}
                          <hr className="m-0 p-0"></hr>
                          {totalPages > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-2">
                              {/* PREV BUTTON */}
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                disabled={currentPage === 1}
                                onClick={() => handlePrev(status)}
                              >
                                Prev
                              </button>

                              {/* PAGE INFO */}
                              <small>
                                Page {currentPage} / {totalPages}
                              </small>

                              {/* NEXT BUTTON */}
                              <button
                                className="btn btn-sm btn-outline-primary"
                                disabled={currentPage === totalPages}
                                onClick={() => handleNext(status)}
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </Droppable>
                  );
                })}
              </div>
            </div>
          </DragDropContext>
        </div>

        <Footer />
      </div>
      <style>{`
        .tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 125%; /* always above */
  left: 50%;
  transform: translateX(-50%);
  background-color: #1d273b;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: normal;
  max-width: 200px;
  transition: all 0.2s ease;
  z-index: 9999;
}

.tooltip-container:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(-4px);
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  top: 100%; /* arrow pointing down */
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #1d273b transparent transparent transparent;
}
      `}</style>
    </div>
  );
};

export default InterviewPipelineSystem;
